import clsx from 'clsx';

import { BaseContainer, type BaseContainerProps } from '@commons/containers/BaseContainer';
import type { DrupalSectionAttributes } from '@commons/types/drupal';

// Type definition for the SectionWrapper component properties.

type Props = BaseContainerProps & {
  attributes: DrupalSectionAttributes;
};

/**
 * SectionWrapper component.
 *
 * Wraps the section with a section element and applies the attributes.
 */

const SectionWrapper = (props: Props) => {
  const { children, attributes, className, ref, ...rest } = props;
  const { id, classes: sectionClasses, attributes: sectionAttributes } = attributes;

  const classes = clsx(className, sectionClasses);

  return (
    <BaseContainer
      as="section"
      id={id}
      ref={ref}
      className={classes}
      {...rest}
      {...sectionAttributes}
    >
      {children}
    </BaseContainer>
  );
};

export default SectionWrapper;
